import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Interweave } from "interweave";
export default function FormSubtext({ text, children }) {
    return (_jsxs("div", { className: "subtext", children: [_jsx(Interweave, { content: text }), " ", children] }));
}
